import "./poster-builder.7ec0a949.js";
import "./poster-builder.b2a72de8.js";
import "./poster-builder.40ac639a.js";
import "./poster-builder.cc8ec761.js";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2835"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2835"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRequire("1enj3");
parcelRequire("eBwC4");
parcelRequire("ekXg5");
parcelRequire("9hC2G");
parcelRequire("3skPo");
parcelRequire("fzSrD");

var $7JB23 = parcelRequire("7JB23");
parcelRequire("3MUFr");

var $6KOho = parcelRequire("6KOho");

var $k4QTz = parcelRequire("k4QTz");
class $d19356632dbef2e0$export$c019608e5b5bb4cb {
    _schema = {};
    _query = {
        size: "posterSize",
        frame: "posterFrame",
        giftwrap: "posterGiftwrapSelect",
        dayLabel: "DayLabel",
        monthLabel: "MonthLabel",
        yearLabel: "YearLabel",
        eventLabel: "EventLabel",
        namesLabel: "NamesLabel",
        posterColorNumber: "PosterColorNumber",
        previousCartItemId: "previousCartItemId",
        printType: "PrintType",
        aluminiumColor: "AluminiumColor"
    };
    _options = {
        settingsPanel: "map",
        posterSize: "small",
        posterFrame: "black",
        acrylBlock: "no-block"
    };
    constructor(){
        this._searchParams = new URLSearchParams(window.location.search);
        // Flips the queries key and value
        this._queryMap = Object.assign({}, ...Object.entries(this._query).map(([a, b])=>({
                [b]: a
            })));
    }
    checkEncodeURI(str) {
        return /\%/i.test(str);
    }
    get(key, defaultValue = null, defaultType = null) {
        let type = this._schema[key] || defaultType;
        let value = this._getOption(key) || defaultValue;
        if (!type) return value || defaultValue;
        if (type === "object" && value) {
            if (this.checkEncodeURI(value)) value = decodeURI(value);
            return JSON.parse(value);
        }
        if (type === "split" && value) return value.replace("[", "").replace("]", "").split(",");
        if (type === "bool") {
            if (value === "true" || value === "1" || value === true) return true;
            if (value === "false" || value === "0" || value === false) return false;
            return this._options[key];
        }
        return value;
    }
    _getOption(key) {
        let value;
        let altKey = this._queryMap[key];
        // Try GET parameters
        value = this._searchParams.get(key);
        if (value !== null) return value;
        // Try GET parameters with custom name
        value = this._searchParams.get(altKey);
        if (value !== null) return value;
        // Try Local storage
        value = localStorage.getItem(key);
        if (value !== null) return value;
        // Return default value
        return this._options[key] || this._options[altKey];
    }
    _getQuery() {}
    all() {
        return this._options;
    }
}



var $47G0t = parcelRequire("47G0t");

var $6Kc1e = parcelRequire("6Kc1e");

var $gF0Ex = parcelRequire("gF0Ex");

var $1OR0H = parcelRequire("1OR0H");

var $8UUYp = parcelRequire("8UUYp");

var $5t1He = parcelRequire("5t1He");

var $gtTze = parcelRequire("gtTze");

var $28FSP = parcelRequire("28FSP");
let $06050ad77f1015e3$var$woocommerceUrl = "https://wallable.nl";
const $06050ad77f1015e3$var$apiBase = "";
let $06050ad77f1015e3$var$marketContext;
let $06050ad77f1015e3$var$t = (key)=>key;
let $06050ad77f1015e3$var$formatCurrency = (value)=>`\u{20AC}${Number(value).toFixed(2).replace(".", ",")}`;
let $06050ad77f1015e3$var$formatDate = (value)=>String(value);
const $06050ad77f1015e3$var$i18nReady = (0, $5t1He.initializeI18n)().then((i18n)=>{
    ({ marketContext: $06050ad77f1015e3$var$marketContext, t: $06050ad77f1015e3$var$t, formatCurrency: $06050ad77f1015e3$var$formatCurrency, formatDate: $06050ad77f1015e3$var$formatDate } = i18n);
    $06050ad77f1015e3$var$woocommerceUrl = $06050ad77f1015e3$var$marketContext.services.woocommerceBaseUrl;
});
const $06050ad77f1015e3$var$options = new (0, $d19356632dbef2e0$export$c019608e5b5bb4cb)();
const $06050ad77f1015e3$var$PosterColors = {
    1: {
        bg: "transparent",
        text: "#000000"
    },
    2: {
        bg: "#f0ece38b",
        text: "#97896aff"
    },
    3: {
        bg: "#c6e0e695",
        text: "#4c747dff"
    },
    4: {
        bg: "#f8d5d58d",
        text: "#b47474ff"
    },
    5: {
        bg: "#cef1ce8d",
        text: "#72ba72ff"
    },
    6: {
        bg: "#fff7d783",
        text: "#b8a557ff"
    }
};
let $06050ad77f1015e3$var$PosterPreviewImage;
let $06050ad77f1015e3$var$ShowMobileSettingPanel = false;
let $06050ad77f1015e3$var$PrintTypeSelected = true;
const $06050ad77f1015e3$var$BuilderName = $6KOho("body").attr("id");
let $06050ad77f1015e3$var$SettingsPanel = $06050ad77f1015e3$var$options.get("settingsPanel", "map");
let $06050ad77f1015e3$var$PosterSize = $06050ad77f1015e3$var$options.get("posterSize", "small");
let $06050ad77f1015e3$var$PosterFrame = $06050ad77f1015e3$var$options.get("posterFrame", "black");
let $06050ad77f1015e3$var$PosterColorNumber = $06050ad77f1015e3$var$options.get("PosterColorNumber", "1");
let $06050ad77f1015e3$var$AcrylBlock = $06050ad77f1015e3$var$options.get("acrylBlock", "black");
let $06050ad77f1015e3$var$AluminiumColor = $06050ad77f1015e3$var$options.get("aluminiumColor", "silver");
let $06050ad77f1015e3$var$PrintType = $06050ad77f1015e3$var$options.get("printType", "paper");
let $06050ad77f1015e3$var$GiftCardText = "";
const $06050ad77f1015e3$var$DayInput = $6KOho("#day-input");
const $06050ad77f1015e3$var$DayLabel = $6KOho(".labels .day");
const $06050ad77f1015e3$var$MonthInput = $6KOho("#month-input");
const $06050ad77f1015e3$var$MonthLabel = $6KOho(".labels .month");
const $06050ad77f1015e3$var$YearInput = $6KOho("#year-input");
const $06050ad77f1015e3$var$YearLabel = $6KOho(".labels .year");
const $06050ad77f1015e3$var$EventInput = $6KOho("#event-input");
const $06050ad77f1015e3$var$EventLabel = $6KOho(".labels .event-content");
const $06050ad77f1015e3$var$NamesInput = $6KOho("#names-input");
const $06050ad77f1015e3$var$NamesLabel = $6KOho(".labels .names");
const $06050ad77f1015e3$var$PosterWrapper = $6KOho(".map-wrapper");
const $06050ad77f1015e3$var$PosterSizeSelect = $6KOho(".js-poster-size");
const $06050ad77f1015e3$var$PosterFrameSelect = $6KOho(".js-poster-frame");
const $06050ad77f1015e3$var$PosterGiftwrapSelect = $6KOho(".js-giftwrap");
const $06050ad77f1015e3$var$GiftCardSelect = $6KOho(".js-giftcard");
const $06050ad77f1015e3$var$AcrylBlockSelect = $6KOho(".js-acryl-block");
const $06050ad77f1015e3$var$PrintTypeSelect = $6KOho(".js-print-type");
const $06050ad77f1015e3$var$debugReporter = (0, $1OR0H.DebugReporter)({
    ajaxUrl: $06050ad77f1015e3$var$apiBase + "/wp-json/wallable/v1/client-diagnostics",
    containerSelector: ".js-notifications",
    shouldShow: ({ meta: meta })=>meta?.action === "add-to-cart" || meta?.action === "add-poster-order",
    extraContext: ()=>({
            builder: $6KOho("body").attr("id")
        })
}).init();
// Load saved poster after locale and market configuration are available.
$06050ad77f1015e3$var$i18nReady.then(()=>{
    $06050ad77f1015e3$var$getSavedPoster();
    $06050ad77f1015e3$var$toggleProductionEnv();
    $06050ad77f1015e3$var$calculatePosterPrice();
    $06050ad77f1015e3$var$resizePosterWrapper();
    $06050ad77f1015e3$var$toggleClearIcons();
    $06050ad77f1015e3$var$setPreviewMode();
});
$6KOho(document).ready(async function() {
    await $06050ad77f1015e3$var$i18nReady;
    window.status = "mapbox-ready";
    setTimeout(()=>{
        $6KOho(".anim-wrapper").removeClass("hidden");
        $6KOho(".loading-wrapper").remove();
    }, "500");
});
// For dismissing panel if previewing from shopping cart
function $06050ad77f1015e3$var$setPreviewMode() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("preview")) $06050ad77f1015e3$var$dismissSettingsPanel();
}
// Input listeners
$6KOho("input.form-control").on("input", function() {
    const posterLabel = this.dataset.posterLabel;
    if (!posterLabel) return;
    let inputValue = $6KOho(this).val();
    if ($6KOho(this).attr("type") === "number" && inputValue >= 0) {
        inputValue = $06050ad77f1015e3$var$formatDateInteger(inputValue);
        $6KOho(this).val(inputValue);
    }
    $6KOho(".labels ." + posterLabel).html(inputValue);
    $6KOho('.js-clear-input[data-field-id="' + posterLabel + '"]').toggle(inputValue !== "");
});
function $06050ad77f1015e3$var$formatDateInteger(inputValue) {
    const validIntegerPattern = /^(0|[1-9]\d*)$/;
    let formattedNumber;
    if (validIntegerPattern.test(inputValue)) formattedNumber = inputValue < 10 ? `0${inputValue}` : `${inputValue}`;
    else {
        // Remove leading zeros and update the input field
        const cleanedValue = inputValue.replace(/^0+/, "0");
        formattedNumber = cleanedValue;
    }
    return formattedNumber;
}
$6KOho(".js-history-back").on("click", function() {
    history.back();
});
// Clear input fields
$6KOho(".js-clear-input").on("click", function() {
    const field = $6KOho(this).data("field-id");
    $6KOho('input.form-control[data-poster-label="' + field + '"]').val("").trigger("input").trigger("focus");
});
// Check if field has value and show clear icon
function $06050ad77f1015e3$var$toggleClearIcons() {
    const inputFields = $6KOho("input.form-control");
    inputFields.each(function() {
        const inputValue = $6KOho(this).val();
        if (inputValue.trim() === "") {
            let emptyField = $6KOho(this).data("poster-label");
            $6KOho('.js-clear-input[data-field-id="' + emptyField + '"]').hide();
        }
    });
}
// Change poster color
$6KOho(".js-style-option").on("click", function() {
    $06050ad77f1015e3$var$PosterColorNumber = $6KOho(this).attr("data-style");
    $06050ad77f1015e3$var$setPosterColor($06050ad77f1015e3$var$PosterColorNumber);
    $06050ad77f1015e3$var$setPosterColorSelection($06050ad77f1015e3$var$PosterColorNumber);
});
function $06050ad77f1015e3$var$setPosterColor(colorNumber) {
    $6KOho(".poster-canvas").css("background-color", $06050ad77f1015e3$var$PosterColors[colorNumber].bg);
    $6KOho(".poster-canvas .labels").css("color", $06050ad77f1015e3$var$PosterColors[colorNumber].text);
    $6KOho(".poster-canvas .divider").css("background-color", $06050ad77f1015e3$var$PosterColors[colorNumber].text);
}
function $06050ad77f1015e3$var$setPosterColorSelection(colorNumber) {
    var selectedColor = $6KOho('.js-style-option[data-style="' + colorNumber + '"]');
    $6KOho(".js-style-option").removeClass("active");
    selectedColor.addClass("active");
    $06050ad77f1015e3$var$dismissSettingsPanel();
}
// Changing poster
function $06050ad77f1015e3$var$setPosterSize(posterSize) {
    $06050ad77f1015e3$var$PosterWrapper.removeClass().addClass("map-wrapper size-" + posterSize + " " + $06050ad77f1015e3$var$PrintType);
}
// Change poster size
$6KOho(".js-size-option").on("click", function() {
    $06050ad77f1015e3$var$PosterSize = $6KOho(this).attr("data-size");
    $06050ad77f1015e3$var$setPosterSize($06050ad77f1015e3$var$PosterSize);
    $06050ad77f1015e3$var$setSizeSelection($06050ad77f1015e3$var$PosterSize);
    $06050ad77f1015e3$var$calculatePosterPrice();
});
function $06050ad77f1015e3$var$setSizeSelection(posterSize) {
    let selectedSize = $6KOho('.js-toggle-for-material[data-material="' + $06050ad77f1015e3$var$PrintType + '"] .js-size-option[data-size="' + posterSize + '"]');
    $6KOho(".js-size-option").removeClass("active");
    selectedSize.addClass("active");
    if ($06050ad77f1015e3$var$PrintType !== "paper") return;
    let framePrice = 0;
    let frameNormalPrice = 0;
    switch(posterSize){
        case "small":
            framePrice = 15;
            frameNormalPrice = 21.95;
            break;
        case "medium":
            framePrice = 20;
            frameNormalPrice = 24.95;
            break;
        case "large":
            framePrice = 35;
            frameNormalPrice = 39.95;
            break;
        default:
            framePrice = 0;
            frameNormalPrice = 0;
    }
    // If extra-large, force no frame
    if (posterSize === "extra-large") {
        $06050ad77f1015e3$var$PosterFrame = "no-frame";
        $06050ad77f1015e3$var$setFrameSelection($06050ad77f1015e3$var$PosterFrame);
        $06050ad77f1015e3$var$setPosterFrame($06050ad77f1015e3$var$PosterFrame);
        $6KOho(".js-frame-option").addClass("disabled");
        $6KOho('.js-frame-option[data-frame="no-frame"]').removeClass("disabled");
        $6KOho("small[frame-normal-price]").text("-");
        $6KOho("small[frame-price]").hide();
    } else {
        $6KOho(".js-frame-option").removeClass("disabled");
        $6KOho("small[frame-price]").show();
        $6KOho("small[frame-price]").text($06050ad77f1015e3$var$formatCurrency(framePrice));
        $6KOho("small[frame-normal-price]").text($06050ad77f1015e3$var$formatCurrency(frameNormalPrice));
        $6KOho(".js-frame-option").not('[data-frame="no-frame"]').attr("data-price", framePrice.toFixed(2));
    }
}
// Change print type
$6KOho(document).on("click", ".js-print-option", function() {
    let SelectedPrintType = $6KOho(this).attr("data-print");
    if ($06050ad77f1015e3$var$PrintType !== SelectedPrintType) {
        $06050ad77f1015e3$var$PrintType = SelectedPrintType;
        $06050ad77f1015e3$var$setPrintType($06050ad77f1015e3$var$PrintType);
    }
    if ($6KOho(this).hasClass("d-block")) $06050ad77f1015e3$var$PrintTypeSelected = true;
    $06050ad77f1015e3$var$togglePrintTypes();
});
$6KOho(document).on("click", ".js-show-print-types", function() {
    $06050ad77f1015e3$var$togglePrintTypes();
});
function $06050ad77f1015e3$var$setPrintType(PrintType) {
    var selectedPrint = $6KOho('.js-print-option[data-print="' + PrintType + '"]');
    $6KOho(".js-print-option").removeClass("active");
    selectedPrint.addClass("active");
    // If acryl
    if (PrintType == "acryl") {
        if ($06050ad77f1015e3$var$PosterSize === "large" || $06050ad77f1015e3$var$PosterSize === "extra-large") $06050ad77f1015e3$var$PosterSize = "small";
        $06050ad77f1015e3$var$PosterFrame = "no-frame";
    // If aluminium
    } else if (PrintType == "aluminium") {
        if ($06050ad77f1015e3$var$PosterSize === "large" || $06050ad77f1015e3$var$PosterSize === "extra-large") $06050ad77f1015e3$var$PosterSize = "medium";
        $06050ad77f1015e3$var$PosterFrame = "no-frame";
        $06050ad77f1015e3$var$setAluminiumColor($06050ad77f1015e3$var$AluminiumColor);
    // If paper
    } else {
        if ($06050ad77f1015e3$var$PosterSize === "xs") $06050ad77f1015e3$var$PosterSize = "small";
        else if ($06050ad77f1015e3$var$PosterSize === "extra-large") $06050ad77f1015e3$var$PosterSize = "large";
        $06050ad77f1015e3$var$AcrylBlock = "no-block";
    }
    $06050ad77f1015e3$var$setAcrylBlock($06050ad77f1015e3$var$AcrylBlock);
    $06050ad77f1015e3$var$setBlockSelection($06050ad77f1015e3$var$AcrylBlock);
    $06050ad77f1015e3$var$setFrameSelection($06050ad77f1015e3$var$PosterFrame);
    $06050ad77f1015e3$var$setPosterFrame($06050ad77f1015e3$var$PosterFrame);
    $06050ad77f1015e3$var$setPosterSize($06050ad77f1015e3$var$PosterSize);
    $06050ad77f1015e3$var$setSizeSelection($06050ad77f1015e3$var$PosterSize);
    $06050ad77f1015e3$var$calculatePosterPrice();
}
function $06050ad77f1015e3$var$togglePrintTypes() {
    if ($06050ad77f1015e3$var$PrintTypeSelected) {
        $6KOho(".js-print-option").hide();
        $6KOho(".js-toggle-for-material").hide();
        $6KOho(".js-show-print-types").show();
        $6KOho(".js-toggle-for-material[data-material='" + $06050ad77f1015e3$var$PrintType + "']").show();
        $6KOho(".js-print-option[data-print='" + $06050ad77f1015e3$var$PrintType + "']").show();
        $06050ad77f1015e3$var$PrintTypeSelected = false;
    } else {
        $6KOho(".js-print-option").show();
        $6KOho(".js-show-print-types").hide();
        $6KOho(".js-toggle-for-material").hide();
        $06050ad77f1015e3$var$PrintTypeSelected = true;
    }
}
// Change aluminium color
$6KOho(".js-color-option").on("click", function() {
    $06050ad77f1015e3$var$AluminiumColor = $6KOho(this).attr("data-color");
    $06050ad77f1015e3$var$setAluminiumColor($06050ad77f1015e3$var$AluminiumColor);
    $06050ad77f1015e3$var$setAluminiumColorSelection($06050ad77f1015e3$var$AluminiumColor);
});
function $06050ad77f1015e3$var$setAluminiumColor(color) {
    $06050ad77f1015e3$var$PosterWrapper.attr("data-aluminium-color", color);
}
function $06050ad77f1015e3$var$setAluminiumColorSelection(color) {
    var selectedColor = $6KOho('.js-color-option[data-color="' + color + '"]');
    $6KOho(".js-color-option").removeClass("active");
    selectedColor.addClass("active");
}
// Change acryl block
$6KOho(".js-block-option").on("click", function() {
    $06050ad77f1015e3$var$AcrylBlock = $6KOho(this).attr("data-block");
    $06050ad77f1015e3$var$setBlockSelection($06050ad77f1015e3$var$AcrylBlock);
    $06050ad77f1015e3$var$setAcrylBlock($06050ad77f1015e3$var$AcrylBlock);
    $06050ad77f1015e3$var$calculatePosterPrice();
});
function $06050ad77f1015e3$var$setBlockSelection(AcrylBlock) {
    var selectedBlock = $6KOho('.js-block-option[data-block="' + AcrylBlock + '"]');
    $6KOho(".js-block-option").removeClass("active");
    selectedBlock.addClass("active");
}
function $06050ad77f1015e3$var$setAcrylBlock(AcrylBlock) {
    $6KOho(".aluminium-stand").hide();
    $6KOho(".acryl-block").show();
    $06050ad77f1015e3$var$PosterWrapper.attr("data-perspective", false);
    if (AcrylBlock == "black") {
        $6KOho(".acryl-block").removeClass("d-none oak").addClass("black");
        $06050ad77f1015e3$var$PosterWrapper.attr("data-perspective", true);
    } else if (AcrylBlock == "oak") {
        $6KOho(".acryl-block").removeClass("d-none black").addClass("oak");
        $06050ad77f1015e3$var$PosterWrapper.attr("data-perspective", true);
    } else $6KOho(".acryl-block").removeClass("oak black").addClass("d-none");
}
// Change poster frame
$6KOho(".js-frame-option").on("click", function() {
    $06050ad77f1015e3$var$PosterFrame = $6KOho(this).attr("data-frame");
    $06050ad77f1015e3$var$setFrameSelection($06050ad77f1015e3$var$PosterFrame);
    $06050ad77f1015e3$var$setPosterFrame($06050ad77f1015e3$var$PosterFrame);
    $06050ad77f1015e3$var$activateGiftwrap($06050ad77f1015e3$var$PosterFrame);
    $06050ad77f1015e3$var$calculatePosterPrice();
});
function $06050ad77f1015e3$var$setPosterFrame(PosterFrame) {
    const frameElement = $6KOho(".poster-frame");
    const frameClasses = [
        "black-frame",
        "oak-frame",
        "white-frame"
    ];
    frameElement.removeClass(frameClasses.join(" ") + " d-none");
    if (frameClasses.includes(PosterFrame + "-frame")) frameElement.addClass(PosterFrame + "-frame");
    else frameElement.addClass("d-none");
    $06050ad77f1015e3$var$activateGiftwrap();
}
function $06050ad77f1015e3$var$setFrameSelection(frame) {
    var selectedFrame = $6KOho('.js-frame-option[data-frame="' + frame + '"]');
    $6KOho(".js-frame-option").removeClass("active");
    selectedFrame.addClass("active");
}
// Toggle giftwrap
$6KOho(".js-giftwrap").on("change", function() {
    $06050ad77f1015e3$var$calculatePosterPrice();
});
function $06050ad77f1015e3$var$activateGiftwrap() {
    if ($06050ad77f1015e3$var$PrintType === "paper" && $06050ad77f1015e3$var$PosterFrame === "no-frame") {
        $06050ad77f1015e3$var$PosterGiftwrapSelect.val("false");
        $6KOho(".js-giftwrap option[value=true]").attr("disabled", "disabled").siblings().removeAttr("disabled");
    } else $6KOho(".js-giftwrap option[value=true]").removeAttr("disabled");
}
// Change giftcard text
$6KOho(".js-giftcard").on("change", function() {
    if ($6KOho(this).val() === "true") {
        $6KOho(".js-giftcard-text").show();
        $06050ad77f1015e3$var$GiftCardText = $6KOho(".js-giftcard-text").val();
    } else {
        $6KOho(".js-giftcard-text").hide();
        $06050ad77f1015e3$var$GiftCardText = "";
    }
    $06050ad77f1015e3$var$calculatePosterPrice();
});
$6KOho(".js-giftcard-text").on("change", function() {
    $06050ad77f1015e3$var$GiftCardText = $6KOho(this).val();
});
// Calculate poster price
function $06050ad77f1015e3$var$calculatePosterPrice() {
    const getPrice = (selector)=>parseFloat($6KOho(selector).find(".active, :selected").attr("data-price")) || 0;
    const subtotalPrice = getPrice($06050ad77f1015e3$var$PosterSizeSelect) + getPrice($06050ad77f1015e3$var$AcrylBlockSelect) + getPrice($06050ad77f1015e3$var$PosterFrameSelect) + getPrice($06050ad77f1015e3$var$PosterGiftwrapSelect) + getPrice($06050ad77f1015e3$var$GiftCardSelect);
    $6KOho(".subtotal").html($06050ad77f1015e3$var$formatCurrency(subtotalPrice));
}
// Create poster preview image
function $06050ad77f1015e3$var$createPosterPreview() {
    $6KOho(".poster-frame, .block-wrapper").addClass("hidden");
    $6KOho(".map-wrapper").addClass("shadow-none");
    const element = document.querySelector(".poster-wrapper");
    (0, (/*@__PURE__*/$parcel$interopDefault($7JB23)))(element, {
        scale: window.devicePixelRatio || 2,
        useCORS: true,
        backgroundColor: "#ffffff"
    }).then((canvas)=>{
        $06050ad77f1015e3$var$PosterPreviewImage = canvas.toDataURL("image/jpeg", 0.8);
        $6KOho(".js-poster-preview").attr("src", $06050ad77f1015e3$var$PosterPreviewImage);
    });
    $6KOho(".map-wrapper").removeClass("shadow-none");
    $6KOho(".poster-frame, .block-wrapper").removeClass("hidden");
}
// For hiding some unnecessary fields on staging
function $06050ad77f1015e3$var$toggleProductionEnv() {}
// For removing default values from poster
function $06050ad77f1015e3$var$removeDefaultValue(value) {
    const defaultValues = [
        "Naam &amp; Naam",
        "Gebeurtenis",
        $06050ad77f1015e3$var$t("datePoster.defaults.names"),
        $06050ad77f1015e3$var$t("datePoster.defaults.names").replaceAll("&", "&amp;"),
        $06050ad77f1015e3$var$t("datePoster.defaults.event")
    ];
    var isMatch = false;
    for(var i = 0; i < defaultValues.length; i++)if (defaultValues[i] === value) {
        isMatch = true;
        break;
    }
    if (isMatch) return "";
    else return value;
}
// For saving design to local storage
function $06050ad77f1015e3$var$saveDesign() {
    localStorage.setItem("posterSize", $06050ad77f1015e3$var$PosterSize);
    localStorage.setItem("posterFrame", $06050ad77f1015e3$var$PosterFrame);
    localStorage.setItem("DayLabel", $06050ad77f1015e3$var$DayLabel.html());
    localStorage.setItem("MonthLabel", $06050ad77f1015e3$var$MonthLabel.html());
    localStorage.setItem("YearLabel", $06050ad77f1015e3$var$YearLabel.html());
    localStorage.setItem("EventLabel", $06050ad77f1015e3$var$EventLabel.html());
    localStorage.setItem("NamesLabel", $06050ad77f1015e3$var$NamesLabel.html());
    localStorage.setItem("PosterColorNumber", $06050ad77f1015e3$var$PosterColorNumber);
    localStorage.setItem("printType", $06050ad77f1015e3$var$PrintType);
    localStorage.setItem("acrylBlock", $06050ad77f1015e3$var$AcrylBlock);
    localStorage.setItem("aluminiumColor", $06050ad77f1015e3$var$AluminiumColor);
}
// For getting design from local storage or parameters
function $06050ad77f1015e3$var$getSavedPoster() {
    // Prepare text labels
    if ($06050ad77f1015e3$var$BuilderName !== "PrintApp") {
        if ($06050ad77f1015e3$var$options.get("DayLabel") !== null) var dayLabel = $06050ad77f1015e3$var$options.get("DayLabel");
        else var dayLabel = "01";
        if ($06050ad77f1015e3$var$options.get("MonthLabel") !== null) var monthLabel = $06050ad77f1015e3$var$options.get("MonthLabel");
        else var monthLabel = "07";
        if ($06050ad77f1015e3$var$options.get("YearLabel") !== null) var yearLabel = $06050ad77f1015e3$var$options.get("YearLabel");
        else var yearLabel = "21";
        if ($06050ad77f1015e3$var$options.get("EventLabel") !== null) var eventLabel = $06050ad77f1015e3$var$options.get("EventLabel");
        else var eventLabel = $06050ad77f1015e3$var$t("datePoster.defaults.event");
        if ($06050ad77f1015e3$var$options.get("NamesLabel") !== null) var namesLabel = $06050ad77f1015e3$var$options.get("NamesLabel");
        else var namesLabel = $06050ad77f1015e3$var$t("datePoster.defaults.names");
    } else {
        var dayLabel = $06050ad77f1015e3$var$options.get("DayLabel");
        var monthLabel = $06050ad77f1015e3$var$options.get("MonthLabel");
        var yearLabel = $06050ad77f1015e3$var$options.get("YearLabel");
        var eventLabel = $06050ad77f1015e3$var$options.get("EventLabel");
        var namesLabel = $06050ad77f1015e3$var$options.get("NamesLabel");
    }
    // Set text labels
    $06050ad77f1015e3$var$DayLabel.html(dayLabel);
    $06050ad77f1015e3$var$DayInput.val(dayLabel);
    $06050ad77f1015e3$var$MonthLabel.html(monthLabel);
    $06050ad77f1015e3$var$MonthInput.val(monthLabel);
    $06050ad77f1015e3$var$YearLabel.html(yearLabel);
    $06050ad77f1015e3$var$YearInput.val(yearLabel);
    $06050ad77f1015e3$var$EventLabel.html(eventLabel);
    $06050ad77f1015e3$var$EventInput.val(eventLabel);
    $06050ad77f1015e3$var$NamesLabel.html(namesLabel);
    $06050ad77f1015e3$var$NamesInput.val(namesLabel);
    if ($06050ad77f1015e3$var$PrintType !== "acryl" && $06050ad77f1015e3$var$PrintType !== "aluminium") {
        if ($06050ad77f1015e3$var$PosterSize === "xs") $06050ad77f1015e3$var$PosterSize = "small";
        if ($06050ad77f1015e3$var$PrintType === "framed-poster" || $06050ad77f1015e3$var$PrintType === "tegel") $06050ad77f1015e3$var$PrintType = "paper";
    }
    $06050ad77f1015e3$var$PosterSizeSelect.val($06050ad77f1015e3$var$PosterSize);
    $06050ad77f1015e3$var$setPosterSize($06050ad77f1015e3$var$PosterSize);
    $06050ad77f1015e3$var$setSizeSelection($06050ad77f1015e3$var$PosterSize);
    $06050ad77f1015e3$var$PrintTypeSelect.val($06050ad77f1015e3$var$PrintType);
    $06050ad77f1015e3$var$setPrintType($06050ad77f1015e3$var$PrintType);
    $6KOho(".js-toggle-for-material").hide();
    $06050ad77f1015e3$var$togglePrintTypes();
    $06050ad77f1015e3$var$PosterFrame = $06050ad77f1015e3$var$options.get("posterFrame");
    $06050ad77f1015e3$var$PosterFrame = $06050ad77f1015e3$var$PosterFrame === "framed" ? "black" : $06050ad77f1015e3$var$PosterFrame;
    $06050ad77f1015e3$var$PosterFrameSelect.val($06050ad77f1015e3$var$PosterFrame);
    $06050ad77f1015e3$var$setPosterFrame($06050ad77f1015e3$var$PosterFrame);
    $06050ad77f1015e3$var$setFrameSelection($06050ad77f1015e3$var$PosterFrame);
    $06050ad77f1015e3$var$activateGiftwrap($06050ad77f1015e3$var$PosterFrame);
    $06050ad77f1015e3$var$setPosterColor($06050ad77f1015e3$var$PosterColorNumber);
    $06050ad77f1015e3$var$setPosterColorSelection($06050ad77f1015e3$var$PosterColorNumber);
}
// Resize canvas
$6KOho(window).on("resize", function() {
    $06050ad77f1015e3$var$resizePosterWrapper();
});
function $06050ad77f1015e3$var$resizePosterWrapper() {
    (0, $6Kc1e.resizePosterPreview)();
}
window.visualViewport?.addEventListener("resize", $06050ad77f1015e3$var$resizePosterWrapper);
// Toggle settings panels
$6KOho(".js-settings-toggle").on("click", function() {
    var target = $6KOho(this).attr("data-target");
    $6KOho(".nav-link").removeClass("active");
    $6KOho(".nav-link[data-target=" + target + "]").addClass("active");
    if (target == "text" && $06050ad77f1015e3$var$SettingsPanel !== "text") {
        $6KOho(".settings-panel").addClass("d-none");
        $6KOho(".settings-panel.text").removeClass("d-none");
        $06050ad77f1015e3$var$SettingsPanel = "text";
    } else if (target == "size" && $06050ad77f1015e3$var$SettingsPanel !== "size") {
        $6KOho(".settings-panel").addClass("d-none");
        $6KOho(".settings-panel.size").removeClass("d-none");
        $06050ad77f1015e3$var$SettingsPanel = "size";
    } else if (target == "shop" && $06050ad77f1015e3$var$SettingsPanel !== "shop") {
        $06050ad77f1015e3$var$setPosterSummary();
        $6KOho(".settings-panel").addClass("d-none");
        $6KOho(".settings-panel.shop").removeClass("d-none");
        $6KOho(".nav-pills .nav-link").removeClass("active");
        $6KOho("#pills-shop-tab").addClass("active");
        $06050ad77f1015e3$var$SettingsPanel = "shop";
    }
    if ($06050ad77f1015e3$var$ShowMobileSettingPanel == false) {
        $6KOho(".side-nav").addClass("shown");
        $06050ad77f1015e3$var$ShowMobileSettingPanel = true;
    }
    $6KOho(".options-container").scrollTop(0);
    $06050ad77f1015e3$var$saveDesign();
});
$6KOho(".js-close-settings").on("click", function() {
    $06050ad77f1015e3$var$dismissSettingsPanel();
});
function $06050ad77f1015e3$var$dismissSettingsPanel() {
    $6KOho(".side-nav").removeClass("shown");
    $06050ad77f1015e3$var$ShowMobileSettingPanel = false;
}
function $06050ad77f1015e3$var$isPrintApp() {
    return $6KOho("html").hasClass("PrintApp");
}
// Prepping shopping cart
function $06050ad77f1015e3$var$setPosterSummary() {
    (0, $gF0Ex.getShoppingBagSummary)($06050ad77f1015e3$var$PosterSize, $06050ad77f1015e3$var$PrintType, $06050ad77f1015e3$var$PosterFrame, $06050ad77f1015e3$var$AcrylBlock, $06050ad77f1015e3$var$t);
    $6KOho(".js-shipping-date").html((0, $47G0t.getShippingDate)({
        t: $06050ad77f1015e3$var$t,
        formatDate: $06050ad77f1015e3$var$formatDate
    }));
    $06050ad77f1015e3$var$createPosterPreview();
}
function $06050ad77f1015e3$var$getProductVariation() {
    const variationKey = $06050ad77f1015e3$var$PrintType === "paper" ? `${$06050ad77f1015e3$var$PosterSize}-${$06050ad77f1015e3$var$PosterFrame}` : $06050ad77f1015e3$var$PosterSize;
    const product = (0, $gtTze.resolveCatalogProduct)($06050ad77f1015e3$var$marketContext.catalog, "date", $06050ad77f1015e3$var$PrintType, variationKey);
    return {
        id: product?.id ?? null,
        variation_id: product?.variationId ?? null
    };
}
// Adding poster to cart
$6KOho(".js-save-poster").on("click", async function() {
    $06050ad77f1015e3$var$saveDesign();
    let ProductID = $06050ad77f1015e3$var$getProductVariation();
    // window.open(url, '_blank').focus();
    $6KOho(this).html(`${$06050ad77f1015e3$var$t("actions.savingDesign")} <span class="spinner-border spinner-border-sm ms-2" aria-hidden="true"></span>`).prop("disabled", true);
    let thumbnailUrl;
    try {
        thumbnailUrl = await (0, $8UUYp.uploadProductScreenshot)($06050ad77f1015e3$var$PosterPreviewImage, $06050ad77f1015e3$var$BuilderName);
    } catch (error) {
        console.error("Product screenshot kon niet worden opgeslagen", error);
        $6KOho(this).html($06050ad77f1015e3$var$t("actions.addToCart")).prop("disabled", false);
        $6KOho(".js-notifications").append(`<div class="js-error alert alert-danger text-center p-2">${$06050ad77f1015e3$var$t("sportsmap.errors.saveFailed")}</div>`);
        return;
    }
    let payload = {
        "add-builder-item-to-cart": true,
        edit_url: (0, $28FSP.getBuilderUrl)($06050ad77f1015e3$var$marketContext, "date-poster", "/?preview"),
        thumbnail: thumbnailUrl,
        product_id: ProductID.id,
        variation_id: ProductID.variation_id,
        poster: {
            size: $06050ad77f1015e3$var$PosterSize,
            giftwrap: $06050ad77f1015e3$var$PosterGiftwrapSelect.val(),
            giftcardText: $06050ad77f1015e3$var$GiftCardText,
            dayLabel: localStorage.getItem("DayLabel"),
            monthLabel: localStorage.getItem("MonthLabel"),
            yearLabel: localStorage.getItem("YearLabel"),
            eventLabel: $06050ad77f1015e3$var$removeDefaultValue(localStorage.getItem("EventLabel")),
            namesLabel: $06050ad77f1015e3$var$removeDefaultValue(localStorage.getItem("NamesLabel")),
            posterColorNumber: localStorage.getItem("PosterColorNumber"),
            main: $06050ad77f1015e3$var$removeDefaultValue(localStorage.getItem("EventLabel")),
            ...[
                "aluminium"
            ].includes($06050ad77f1015e3$var$PrintType) && {
                aluminiumColor: localStorage.getItem("aluminiumColor")
            },
            ...[
                "aluminium",
                "acryl"
            ].includes($06050ad77f1015e3$var$PrintType) && {
                acrylBlock: localStorage.getItem("acrylBlock")
            },
            ...[
                "paper"
            ].includes($06050ad77f1015e3$var$PrintType) && {
                frame: $06050ad77f1015e3$var$PosterFrame
            }
        },
        pdf: {
            type: "date-poster",
            print: $06050ad77f1015e3$var$PrintType === "paper" && $06050ad77f1015e3$var$PosterFrame !== "no-frame" ? "framed-poster" : $06050ad77f1015e3$var$PrintType
        }
    };
    // console.log("Payload: ", payload);
    let action = "add-to-cart";
    const endpoint = $06050ad77f1015e3$var$apiBase + "/wp-json/wallable/v1/" + action;
    let didRetryAsForm = false;
    const runAjax = (useFormEncoding = false)=>{
        return $6KOho.ajax({
            url: endpoint,
            type: "POST",
            timeout: 20000,
            ...useFormEncoding ? {
                data: {
                    payload: JSON.stringify(payload)
                }
            } : {
                contentType: "application/json",
                data: JSON.stringify(payload)
            },
            error: (jqXHR, textStatus, errorThrown)=>{
                if (!useFormEncoding && !didRetryAsForm && jqXHR?.status === 0) {
                    didRetryAsForm = true;
                    return runAjax(true);
                }
                console.error(jqXHR, textStatus, errorThrown);
                setTimeout(()=>{
                    if (!$6KOho(".js-notifications").find(".js-error").length) $6KOho(".js-notifications").append(`<div class="js-error alert alert-danger text-center p-2">${$06050ad77f1015e3$var$t("errors.generic")}</div>`);
                    $06050ad77f1015e3$var$debugReporter.show({
                        meta: {
                            action: action,
                            didRetryAsForm: didRetryAsForm
                        },
                        request: {
                            url: endpoint,
                            method: "POST",
                            mode: useFormEncoding ? "form" : "json",
                            origin: window.location.origin,
                            woocommerceUrl: $06050ad77f1015e3$var$woocommerceUrl,
                            online: navigator.onLine,
                            visibilityState: document.visibilityState
                        },
                        response: {
                            status: jqXHR?.status,
                            statusText: jqXHR?.statusText || textStatus,
                            thrownError: errorThrown ? String(errorThrown) : null,
                            responseText: (jqXHR?.responseText || "").slice(0, 4000)
                        }
                    });
                    $6KOho(this).html($06050ad77f1015e3$var$t("actions.addToCart")).prop("disabled", false);
                }, 500);
            },
            success: ()=>{
                if (action === "add-to-cart") {
                    $6KOho(this).html($06050ad77f1015e3$var$t("actions.addToCart")).prop("disabled", false);
                    window.location = $06050ad77f1015e3$var$woocommerceUrl + "/cart/";
                } else {
                    if (!$6KOho(".js-notifications").find(".js-error").length) $6KOho(".js-notifications").append(`<div class="js-success alert alert-success text-center p-2">&#x2713; ${$06050ad77f1015e3$var$t("actions.posterAdded")}</div>`);
                    $6KOho(this).html($06050ad77f1015e3$var$t("actions.addToCart")).prop("disabled", false);
                }
            }
        });
    };
    runAjax(false);
});
// Tooltips
if (!$06050ad77f1015e3$var$isPrintApp()) {
    var $06050ad77f1015e3$var$tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    var $06050ad77f1015e3$var$tooltipList = $06050ad77f1015e3$var$tooltipTriggerList.map(function(tooltipTriggerEl) {
        return new $k4QTz.Tooltip(tooltipTriggerEl);
    });
}


//# sourceMappingURL=date-poster.6d7a1652.js.map
